import React from 'react';
import PropTypes from 'prop-types';
import delve from 'dlv';

import format from '../../../utils/format';
// import { ESRI_YEAR_DEFAULTS } from '../../../constants';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';

export function HouseholdsDemographics({ households, radii, viewer }) {
  const { radiusOne, radiusTwo, radiusThree } = radii;
  let displayOne = `${radiusOne} Mile Radius`;
  let displayTwo = `${radiusTwo} Mile Radius`;
  let displayThree = `${radiusThree} Mile Radius`;

  if (delve(viewer, 'componentDisplayOrder.demographicsMinutes')) {
    displayOne = `${viewer.componentDisplayOrder.demographicsMinutes.minuteOne} Minutes`;
    displayTwo = `${viewer.componentDisplayOrder.demographicsMinutes.minuteTwo} Minutes`;
    displayThree = `${viewer.componentDisplayOrder.demographicsMinutes.minuteThree} Minutes`;
  }

  return (
    <section>
      <ViewerPrimaryColorUserStyle domStyle="color">
        <h4 className="section-title">Households</h4>
      </ViewerPrimaryColorUserStyle>
      <div className="section-body">
        <div className="detail-card-wrapper">
          <div className="detail-card">
            <div className="detail-card-inner">
              <ViewerPrimaryColorUserStyle domStyle="color">
                <span>{format(households.radiusOne)}</span>
              </ViewerPrimaryColorUserStyle>
              <br />{displayOne}
            </div>
          </div>
          <div className="detail-card">
            <div className="detail-card-inner">
              <ViewerPrimaryColorUserStyle domStyle="color">
                <span>{format(households.radiusTwo)}</span>
              </ViewerPrimaryColorUserStyle>
              <br />{displayTwo}
            </div>
          </div>
          <div className="detail-card">
            <div className="detail-card-inner">
              <ViewerPrimaryColorUserStyle domStyle="color">
                <span>{format(households.radiusThree)}</span>
              </ViewerPrimaryColorUserStyle>
              <br />{displayThree}
            </div>
          </div>
        </div>
        {/* <div className="data-credit">
          Source: ESRI<sup>&reg;</sup>, { ESRI_YEAR_DEFAULTS.currentYear }
        </div> */}
      </div>
    </section>
  );
}

HouseholdsDemographics.propTypes = {
  households: PropTypes.object.isRequired,
  radii: PropTypes.object.isRequired,
  viewer: PropTypes.object,
};

export default HouseholdsDemographics;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailDemographics/HouseholdsDemographics.js